import { getCommonQuickNavPages } from "constants/quickNav/common";
import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";
import { SETTINGS_QUICK_NAV_PAGES } from "constants/quickNav/settings";
import { QUICK_NAV_CONDITION, QuickNavPage } from "constants/quickNav/types";

const {
  HOME,
  DATA_SOURCES,
  TRANSACTIONS,
  FINANCIALS,
  REVENUE,
  EXPENSE,
  ACCOUNTING,
} = WRITE_PERMISSION_KEYS;

const { HAS_INDIAN_ENTITY } = QUICK_NAV_CONDITION;

const BOOKS_HOME_PATH = "/books";

export const BOOKS_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Home", path: BOOKS_HOME_PATH, permissionKey: HOME },
  {
    name: "Data Sources",
    path: "/books/data-sources",
    permissionKey: DATA_SOURCES,
  },
  {
    name: "Transactions",
    path: "/books/transactions",
    permissionKey: TRANSACTIONS,
  },

  {
    name: "Reports",
    path: "/books/live-financials",
    permissionKey: FINANCIALS,
  },
  {
    name: "Reports: Balance sheet",
    path: "/books/live-financials/balance-sheet",
    permissionKey: FINANCIALS,
  },
  {
    name: "Reports: Income statement",
    path: "/books/live-financials/income-statement",
    permissionKey: FINANCIALS,
  },
  {
    name: "Reports: Cash Flow Statement",
    path: "/books/live-financials/cash-flow-statement",
    permissionKey: FINANCIALS,
  },
  {
    name: "Others Reports",
    path: "/books/live-financials/others",
    permissionKey: FINANCIALS,
  },
  {
    name: "Financial closing",
    path: "/books/financial-closing",
    permissionKey: FINANCIALS,
  },
  {
    name: "Reports: Exports",
    path: "/books/all-reports",
    permissionKey: FINANCIALS,
  },

  {
    name: "Invoices",
    path: "/books/invoices-and-customers",
    permissionKey: REVENUE,
  },
  {
    name: "Revenue Metrics",
    path: "/books/revenue-metrics",
    permissionKey: REVENUE,
  },
  {
    name: "Revenue: Customers",
    path: "/books/revenue/customers",
    permissionKey: REVENUE,
  },
  { name: "My Products", path: "/books/my-products", permissionKey: REVENUE },
  {
    name: "Revenue Recognition",
    path: "/books/revenue-schedule",
    permissionKey: REVENUE,
  },

  {
    name: "Expenses: Vendors",
    path: "/books/expenses/vendors",
    permissionKey: EXPENSE,
  },
  { name: "Bills", path: "/books/bills-and-vendors", permissionKey: EXPENSE },
  { name: "Payroll", path: "/books/payroll", permissionKey: EXPENSE },
  {
    name: "Expense Recognition",
    path: "/books/expense-schedule",
    permissionKey: EXPENSE,
  },

  {
    name: "General Ledger",
    path: "/books/categories",
    permissionKey: ACCOUNTING,
    query: { hideZero: true },
  },
  {
    name: "Trial Balance",
    path: "/books/trial-balance",
    permissionKey: ACCOUNTING,
  },
  {
    name: "Chart of Accounts",
    path: "/books/chart-of-accounts",
    permissionKey: ACCOUNTING,
  },
  {
    name: "Reconciliations",
    path: "/books/reconciliation",
    permissionKey: ACCOUNTING,
  },
  {
    name: "Journal Entries",
    path: "/books/journal-entries",
    permissionKey: ACCOUNTING,
  },
  {
    name: "Fixed Assets",
    path: "/books/fixed-assets",
    permissionKey: ACCOUNTING,
  },

  {
    name: "Intragroup: Transfers",
    path: "/books/intragroup/transfers",
    conditions: [HAS_INDIAN_ENTITY],
  },
  {
    name: "Intragroup: Services",
    path: "/books/intragroup/services",
    conditions: [HAS_INDIAN_ENTITY],
  },

  { name: "Bookkeeping Services", path: "/books/services" },
  {
    name: "Books Settings: Accounting",
    path: "/books/books-settings",
    query: { tab: "accounting" },
  },
  {
    name: "Books Settings: Rules",
    path: "/books/books-settings",
    query: { tab: "rules" },
  },
  {
    name: "Books Settings: Default Categories",
    path: "/books/books-settings",
    query: { tab: "default-categories" },
  },
  {
    name: "Books Settings: Chart of Accounts",
    path: "/books/books-settings",
    query: { tab: "chart-of-accounts" },
  },
  {
    name: "Books Settings: Classifications",
    path: "/books/books-settings",
    query: { tab: "classifications" },
  },
  {
    name: "Books Settings: Invoices",
    path: "/books/books-settings",
    query: { tab: "invoices" },
  },
  {
    name: "Books Settings: Bills",
    path: "/books/books-settings",
    query: { tab: "bills" },
  },

  ...getCommonQuickNavPages(BOOKS_HOME_PATH),
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES.filter(({ path }) => path !== BOOKS_HOME_PATH),
];
